/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { gql } from '@apollo/client';

const findProductRecommendationsSF = (queryName = 'productRecommendationsSF') => (
    gql`query ${queryName} (
        $brand: String!
        $environment: String!
        $user: UserSF!
        $targeting: TargetingSF!
        $userAttributes: [UserAttributesSF]
        $isHoldoutEligible: Boolean!
        $resolveIdentity: Boolean!
    ) {
        productRecommendationsSFMulti(
            brand: $brand,
            environment: $environment,
            user: $user,
            targeting: $targeting,
            userAttributes: $userAttributes,
            isHoldoutEligible: $isHoldoutEligible
            resolveIdentity: $resolveIdentity
        ) {
            products{
                partNumber
                name
                seo{ url }
                image{
                    path
                    name
                },
                skuPriceRange{
                    sale{ value },
                    retail{ value }
                },
                productSkus{
                    name
                },
                productType,
                productDeliveryType,
                isPassportEligible
            }
            campaign
            content
            isHoldOut
        }
    }`
);

export default findProductRecommendationsSF;
